// @ts-nocheck
import { node } from "~/util/dom";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";

Mapy.SEO = {
	set: function (title: string, descriptionText? = "", keywords?: string, caller?: any) {
		//console.trace();
		let titleText = title;
		const lang = CONFIG.defaultLang;
		let suffix = `Mapy.com${["pl", "sk", "de", "en"].indexOf(lang) === -1 ? "" : _("seo.titleActiveLanguage")}`;
		const galleryLock = Mapy.getComponent("gallery") && Mapy.getComponent("gallery").isActive();
		const photoDetailLock = Mapy.getComponent("photoDetail") && Mapy.getComponent("photoDetail").isActive();

		// podminka pro nastaveni title spravne, kdyz je aktivni galerie nebo detail fotky, ktery neni v poradi, pac je async
		if ((!galleryLock && !photoDetailLock)
			|| (galleryLock && !photoDetailLock && caller === Mapy.getComponent("gallery"))
			|| (photoDetailLock && caller === Mapy.getComponent("photoDetail"))) {
			if ((window.location.pathname && window.location.pathname !== "/" && window.location.pathname !== `/${CONFIG.defaultLang}` && window.location.pathname !== `/${CONFIG.defaultLang}/`) && Mapy.active[0] !== Mapy.getComponent("search")) {
				if (titleText) {
					suffix = ` • ${suffix}`;
				}
				titleText += suffix;
			} else if (Mapy.active[0] !== Mapy.getComponent("search")) {
				titleText = suffix;
			}
			this._setTitle(Mapy.Util.replaceHtmlEntities(titleText));

			this._setDescription(Mapy.Util.replaceHtmlEntities(descriptionText));
			this._setKeywords(Mapy.Util.replaceHtmlEntities(keywords));
		}
	},

	setAlternate: function () {
		if (!CONFIG.isScreenshoter) {
			const links = Array.from(document.querySelectorAll("link[rel=alternate]"));
			const langs = Mapy.getComponent("languageControl").LANGUAGE;
			const hrefBuild = lang => {
				let href = `${location.protocol}//`;

				href += `${CONFIG.BASE_DOMAIN}/${lang.type}`;
				href += `${location.pathname.replace(`/${CONFIG.defaultLang}`, "")}${location.search}`;

				return href.replace("&amp;", "&");
			};

			const link = node("link", { rel: "alternate", hreflang: "x-default", href: hrefBuild({ type: "en" }) });

			links[0] ? links[0].after(link) : document.head.append(link);

			langs.forEach(lang => {
				if (!lang.hide) {
					const lnk = node("link", { rel: "alternate", hreflang: lang.type, href: hrefBuild(lang) });

					links[0] ? links[0].after(lnk) : document.head.append(lnk);
				}
			});

			links.forEach(lnk => lnk.remove());
		}
	},

	_setTitle: function (titleText: string) {
		document.title = titleText;

		const titleTag = document.getElementsByTagName("title")[0];
		const titleOg = document.querySelector("head meta[property='og:title']");

		if (titleTag) {
			if (titleOg) {
				titleOg.setAttribute("content", titleText);
			}
			try { // IE8 hnije
				Mapy.Util.clear(titleTag);
				titleTag.appendChild(Mapy.Util.text(titleText));
			} catch (ex) {
				//
			}
		}
	},

	_setDescription: function (text: string) {
		const descriptionText = text || _("search.seoDescription");
		const descriptionTag = document.querySelector("head meta[name=description]");
		const descriptionOg = document.querySelector("head meta[property='og:description']");

		if (descriptionTag) {
			descriptionTag.setAttribute("content", descriptionText);
			if (descriptionOg) {
				descriptionOg.setAttribute("content", descriptionText);
			}
		}
	},

	_setKeywords: function (kw?: string) {
		const keywords = kw || _("search.seoKeywords");
		let keywordsString = "";

		if (keywords instanceof Array) {
			keywordsString = keywords.join(", ");
		} else {
			keywordsString = keywords.toString();
		}

		const keywordsTag = document.querySelector("head meta[name=keywords]");

		if (keywordsTag) {
			keywordsTag.setAttribute("content", keywordsString);
		}
	},
};
